import { render, staticRenderFns } from "./InvoiceDetails_ItemsSummary.vue?vue&type=template&id=d9bdd06c&"
import script from "./InvoiceDetails_ItemsSummary.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetails_ItemsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports